<template>
  <!-- 列表 -->
  <div>

    <!-- 商品信息任务 -->
    <baseBreadcrumb :page="$t('message.productInfoTask')" :menu="$t('message.spotCheck')" />
    <div class="body">
      <div class="tab">
        <div class="tabOpt" :class="{ act: datas.status === item.status }" v-for="(item, index) in tabs" :key="index"
          @click="search(item)">
          {{ item.name }}
          <span v-if="index > 0">({{ item.count }})</span>
        </div>

      </div>
      <!-- 搜索项 -->
      <div class="search">
        <div class="left">
          <div class="item">
            <el-date-picker format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange"
              range-separator="至" v-model="createdTime" :default-time="['00:00:00', '23:59:59']"
              start-placeholder="任务生成日期起始" end-placeholder="任务生成日期结束" clearable>
            </el-date-picker>
          </div>
          <div class="item">
            <el-date-picker format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange"
              range-separator="至" v-model="executeTime" :default-time="['00:00:00', '23:59:59']"
              start-placeholder="任务完成日期起始" end-placeholder="任务完成日期结束" clearable>
            </el-date-picker>
          </div>
          <!-- 任务编号 -->
          <div class="item">
            <el-input v-model="datas.task_sn" :placeholder="$t('message.taskNumber')"></el-input>
          </div>
          <!-- 执行人 -->
          <div class="item">
            <el-select v-model="datas.execute_by" :placeholder="$t('message.executor')" clearable filterable>
              <el-option v-for="item in adminList" :key="item.key" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <!-- 负责人 -->
          <div class="item">
            <el-select v-model="datas.liable_id" :placeholder="$t('message.personInCharge')" clearable filterable>
              <el-option v-for="(item, index) in adminList" :key="index" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="search">
        <div class="left">
          <!-- 订单配送单 -->
          <div class="item">
            <el-input v-model="datas.order_sn" :placeholder="$t('message.orderDistribution')" clearable></el-input>
          </div>
          <!--任务类型  -->
          <div class="item"> <el-select v-model="datas.task_type" :placeholder="$t('message.taskType')" clearable
              filterable>
              <el-option v-for="item in options" :key="item.key" :label="item.name" :value="item.key">
              </el-option>
            </el-select></div>

          <div class="item">
            <!-- 搜索 -->
            <el-button type="primary" @click="search({ status: datas.status })">{{ $t('message.search') }}</el-button>
            <el-button @click="reset">{{ $t('message.reset') }}</el-button>
          </div>
        </div>

      </div>
      <!-- 列表 -->
      <div class="table">
        <ol>
          <li class="flex05">NO</li>
          <!-- 基础信息 -->
          <li class="flex2">{{ $t('message.basicInformation') }}</li>

          <!-- 任务要求 -->
          <li>{{ $t('message.taskRequirements') }}</li>
          <!-- : '任务执行订单' -->
          <li class="flex3">{{ $t('message.taskExecutionOrder') }}</li>
          <!-- 备注 -->
          <li>{{ $t('message.remark') }}</li>
          <!-- 状态 -->
          <li>{{ $t('message.status') }}</li>
          <!-- 操作 -->
          <li>{{ $t('message.operation') }}</li>
        </ol>
        <ul v-for="(item, index) in tableData" :key="index">
          <li class="flex05">
            {{ item.rowNumber }}
          </li>
          <!-- 基础信息 -->
          <li class="flex2">
            <div class="template">
              <p> 任务编号：{{ item.task_sn }}</p>
              <p> 来源：自动创建</p>
              <p> 执行人：{{ item.execute_by_admin ? item.execute_by_admin.realname : '' }} <el-button type="primary"
                  size="mini" @click="editExecutor(item)" v-if="item.status == 0">编辑</el-button></p>
              <p> 消息同步推送：<span v-for="name in item.msg_receive_list" :key=name.id>{{ name.realname }}、</span></p>
              <p> 生成日期：{{ item.created_at }}</p>
            </div>
          </li>
          <!-- 任务要求 -->
          <li>
            <div class="template">
              <p> {{ item.task_type_name }} </p>
            </div>
          </li>
          <!-- : '任务执行订单' -->
          <li class="flex3">
            <div class="template" v-if="item.task_type == 1">
              <div class="row" v-for="(record_task_detail, detailindex) in item.record_task_detail" :key="detailindex">
                <router-link :to="'/orderPaymentDetail?order_sn=' + record_task_detail.order_sn" target="_blank"
                  class="a-link">
                  {{ record_task_detail.order_sn }}
                </router-link>
                -No{{ record_task_detail.sorting }}
                <!-- 商品信息 -->
                <div class="volume-item">
                  <span> 长：{{ record_task_detail.order_detail.volume.split('x')[0] }}cm ，</span>
                  <span>宽 ：{{
                    record_task_detail.order_detail.volume.split('x')[1]
                  }}cm ， </span>
                  <span>高：{{ record_task_detail.order_detail.volume.split('x')[2] }}cm </span>
                </div>
                <div class="volume-item">
                  <span>
                    单个重量：{{ record_task_detail.order_detail.weight }}g
                  </span>
                </div>
              </div>

            </div>
            <!-- 记录服务操作时长-->
            <div class="template" v-if="item.task_type == 2">
              <div class="item" v-for="(record_task_detail, detailindex) in item.record_task_detail" :key="detailindex">
                <div class="row">
                  <router-link :to="'/orderPaymentDetail?order_sn=' + record_task_detail.order_sn" target="_blank"
                    class="a-link">
                    {{ record_task_detail.order_sn }}
                  </router-link>
                  -No{{ record_task_detail.sorting }}
                  <span style="margin-left: 30px;"> 普通检品单个时长：{{
                    record_task_detail.order_detail.duration_extend ?
                      record_task_detail.order_detail.duration_extend.inspect_minute : '' }} 分钟</span>
                </div>
                <div class="row">
                  附加服务单个操作时长
                </div>
                <div v-if="record_task_detail.order_detail.duration_extend">
                  <div class="row"
                    v-for="(option, optionIndex) in record_task_detail.order_detail.duration_extend.duration_json"
                    :key="optionIndex">
                    {{ optionIndex + 1 }} {{ option.name }}：{{ option.minute }} 分钟
                  </div>
                </div>

              </div>

            </div>
          </li>
          <!-- 备注 -->
          <li>
            <el-input type="textarea" v-model="item.remark" @blur="recordUpdateRemark(item)"></el-input>
          </li>
          <!-- 状态 -->
          <li>
            <div class="status">
              {{ item.status_name }}
              <p v-if="item.completed_at">完成时间：{{ item.completed_at }}</p>
            </div>
          </li>
          <!-- 操作 -->
          <li>
            <div class=" btn">
              <!-- 提醒执行人 关闭任务-->
              <div v-if="item.status == 0">
                <!-- 提醒执行人 -->
                <p>
                  <el-button type="success" class="primary" @click="recordRemindTask(item.task_sn)">{{
                    $t('message.remindExecutor') }}</el-button>
                </p>
                <!-- 关闭任务 -->
                <p>
                  <el-button type="primary" @click="spotCancel(item)">{{ $t('message.closeTask') }}</el-button>
                </p>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 关闭原因 -->
    <closeTask ref="closeTask" />
    <!-- 编辑执行人  -->
    <el-dialog :title="$t('message.editExecutor')" :close-on-click-modal="false" :visible.sync="executorDialogVisible"
      width="380px" center>
      <div class="row">

        <div class="val" style="margin: 0 auto;">
          <el-select v-model="updateExecuteBytData.execute_by" placeholder="请选择执行人">
            <el-option v-for="item in adminList" :key="item.id" :label="item.realname" :value="item.id" />
          </el-select>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 确定 -->
        <el-button type="primary" @click="recordUpdateExecuteBy">
          {{ $t("message.ok") }}
        </el-button>
        <!--取 消  -->
        <el-button @click="executorDialogVisible = false">
          {{ $t("message.cancel") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import closeTask from './components/closeTask'
export default {
  components: {
    closeTask,
  },
  data() {
    return {
      status: '',
      tabs: [],//列表tab统计
      options: [], //分类枚举
      executeTypeList: [],//执行人类型枚举
      adminList: [],// 责任人
      createdTime: [],
      executeTime: [],
      datas: {
        page: 1, pageSize: 20, status: ''
      },
      tableData: [],
      total: 0,
      itemData: {},
      reparation_sn: '',
      spot_detail_id: 0,
      // 创建任务
      isCreate: false,
      dialogVisible: false,
      taskType: '',
      // 编辑截止时间
      updateExecuteBytData: {
        task_sn: '',
        end_at: '',
      },
      executorDialogVisible: false,
    };
  },
  created() {
    // 同组织各工种账号列表
    this.$api.getAuthWorkGroupAdminDepart({ format_list: 1 }).then(res => {
      this.adminList = res.data
    })
    // 分类枚举
    this.$api.spotCheckApi.taskTypeList().then(res => {
      this.options = res.data
    })
    // 执行人
    this.$api.spotCheckApi.executeTypeList().then(res => {
      this.executeTypeList = res.data
    })
    this.taskListTab()

    this.taskList()
  },
  methods: {
    // 列表tab统计
    taskListTab() {
      this.$api.spotCheckApi.taskListTab().then(res => {
        this.tabs = res.data


      })
    },
    taskList() {
      // 优化时间参数处理
      const setTimeParams = (source, targetStart, targetEnd) => {
        if (source) {
          this.datas[targetStart] = source[0];
          this.datas[targetEnd] = source[1];
        } else {
          this.datas[targetStart] = '';
          this.datas[targetEnd] = '';
        }
      };
      // 处理时间参数
      setTimeParams(this.createdTime, 'created_at_start', 'created_at_end');
      setTimeParams(this.executeTime, 'execute_at_start', 'execute_at_end');
      // 发起请求
      this.$api.spotCheckApi.taskList(this.datas).then(res => {
        this.tableData = res.data.data;
        this.total = res.data.total;
      });
    },
    // 搜索
    search(item) {

      if (item) {
        this.datas.status = item.status
      }
      this.datas.page = 1;
      this.datas.page = 1;
      this.taskList();
      this.taskListTab();
    },
    // 重置
    reset() {
      this.datas = {
        page: 1,
        pageSize: 20,
        status: "",
        confirm_status: "",
        is_over_time: "",
        created_at_start: '',
        created_at_end: '',
        execute_at_start: '',
        execute_at_end: '',
        liable_id: '',
        task_type: '',
        execute_abnormal: '',
        task_sn: '',
        execute_by: '',
        order_sn: ''
      };
      this.createdTime = []
      this.executeTime = []
      this.taskList();
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.taskList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.taskList();
    },
    //标签类型
    setType(status, status_name) {
      if (status == -1) {
        return 'info'
      } else if (status == 20) {
        return 'success'
      } else if (status == 1) {
        return 'danger'
      } else if (status == 10 && status_name == '待执行') {
        return 'warning'
      }

    },

    //关闭任务
    spotCancel(item) {
      this.$confirm('确认关闭任务吗？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.$api.spotCheckApi.recordCloseTask({ task_sn: item.task_sn }).then(res => {
          // 发起请求
          this.taskList()
          this.$message({
            message: res.msg,
            type: 'success'
          })
        });
      }).catch(() => {
      });
    },
    // 提醒执行人
    recordRemindTask(task_sn) {
      this.$api.spotCheckApi.recordRemindTask({ task_sn }).then(res => {
        this.$confirm('消息发送成功', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          // 发起请求

        }).catch(() => {
        });
      });
    },
    // 编辑备注
    recordUpdateRemark(item) {
      let datas = {
        task_sn: item.task_sn,
        remark: item.remark,
      }
      this.$api.spotCheckApi.recordUpdateRemark(datas)
    },
    // 修改执行人
    editExecutor(item) {
      this.updateExecuteBytData = {
        task_sn: item.task_sn,
        execute_by: item.execute_by,
      }
      this.executorDialogVisible = true
    },
    // 更新执行人
    recordUpdateExecuteBy() {
      this.$api.spotCheckApi.recordUpdateExecuteBy(this.updateExecuteBytData).then(res => {
        this.$message({
          message: res.msg,
          type: 'success'
        })
        this.executorDialogVisible = false
        this.taskList()
      })
    }

  }
}
</script>
<style lang='scss' scoped>
.tab {
  display: flex;
  background: #F8F8F8;
  align-items: center;
  border-bottom: 1px solid #edeff4;
  margin-bottom: 20px;

  .tabOpt {
    height: 50px;
    min-width: 160px;
    padding: 0 30px;
    font-size: 18px;
    line-height: 50px;
    margin-bottom: -2px;
    box-sizing: border-box;
    text-align: center;
    border-top: solid 2px transparent;
    border-bottom: solid 2px transparent;
    cursor: pointer;


  }

  .act {
    color: #b4272d;
    border-top: solid 2px #b4272d;
    border-left: solid 1px #edeff4;
    border-right: solid 1px #edeff4;
    border-bottom: solid 2px #f8f8f8;
    background-color: #f8f8f8;
  }
}

.search {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;

  .left {
    display: flex;

    .item {
      margin-right: 20px;
    }
  }
}

.table {
  position: relative;

  ol {
    height: 50px;
    position: sticky;
    top: 0;
    left: 0;
    z-index: 99;

  }

  ul {
    padding: 20px 0;
    background-color: #fff;

    /deep/.el-textarea__inner {
      height: 150px !important;
      resize: none;
      padding: 5px;
    }
  }

  li {
    padding: 0px 10px;
  }

  .flex05 {
    flex: 0.5;

  }

  .flex2 {
    flex: 2;
  }

  .flex3 {
    flex: 5;

    .row {
      display: flex;

      .volume-item {
        margin-left: 20px;
      }
    }
  }

  .status {
    text-align: center;
  }

  .template {
    width: 100%;

    p {
      line-height: 22px;
    }

    .item {
      padding: 10px;
      background-color: #f8f8f8;
      border-radius: 4px;
      margin-bottom: 10px;

      .type {
        position: relative;
        font-weight: 600;

        .el-button {
          position: absolute;
          top: 0;
          right: 0;
        }
      }



      .image {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;

        .images {
          flex: 1;
          overflow: hidden;
        }


      }

      &:nth-last-child(1) {
        margin: 0;
      }


    }
  }

  .btn {
    p {
      margin-bottom: 12px;

      &:nth-last-child(1) {
        margin: 0;
      }
    }

    .el-button {
      width: 110px !important;
    }
  }
}

.row {
  display: flex;
  padding: 0 10px;

  .label {
    margin-right: 10px;
    line-height: 40px;

    span {
      color: red;
      margin-right: 5px;
    }
  }
}
</style>